interface SaveYourLookPillProps {
  onClick: () => void;
}

export default function SaveYourLookPill({ onClick }: SaveYourLookPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Save your look"
      style={{
        background: "#C84B2F",
        color: "#FFFFFF",
        border: "none",
        borderRadius: 20,
        padding: "6px 14px",
        fontSize: 13,
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        cursor: "pointer",
        minHeight: 44,
      }}
    >
      <i className="ti ti-bookmark" style={{ fontSize: 14 }} />
      Save your look
    </button>
  );
}
